import linkPreviewPluginTrigger from './utils/linkPreviewPluginTrigger';
import createLazyPlugin from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { lazyCreateLinkPreview } from 'owa-link-preview';
import { LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "LinkPreview" */ './plugin/LinkPreviewPlugin');
});
export var LazyLinkPreviewPluginClass = createLazyPlugin(lazyModule, function (m) { return m.default; }, 'LinkPreview', linkPreviewPluginTrigger);
export { lazyCreateLinkPreview };
//# sourceMappingURL=index.js.map